//引入Vuex
import Vuex from 'vuex'
import Vue from 'vue';
Vue.use(Vuex)

//1.创建actions对象，用于传递方法与值
const actions = {

   
}

//2.创建mutations对象，用于操作数据
const mutations = {
   
}

//3.创建state，用于存储数据
const state = {
  
}

//4.创建getters,用于创建公共方法
const getters = {
  

}
//创建store对象
export default new Vuex.Store({
    actions,
    mutations,
    state,
    getters
})


